module.exports = __webpack_public_path__ + "static/media/Imagem 38@3x.72492b0a.png";